import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IMessage {
  anneeScolaire?: string;
  codeEtab?: string;
  codeEtabmessageId?: number;
  messageId: number;
  sessionId?: string;
  targetAppId?: string;
  sender?: string;
  phone?: string;
  messageTitle?: string;
  messageContent?: string;
  alertLevel?: string;
  messageArcived?: number;
  favori?: number;
  deleted?: number;
  transactionId?: null;
  sentAt?: string | null;
  createdAt?: number;
  appSelected?: string;
  sendBoxCreatedAt?: string;
}


export interface IMessagerieState {
  messages: IMessage[];

}


const initialState: IMessagerieState = {
  messages: []
}

export const userSlice = createSlice({
  name: "messagerie",
  initialState: initialState,

  reducers: {

    addMessage: (state, action: PayloadAction<IMessage[]>) => {
      state.messages = [...action.payload, ...state.messages];
    },

    setMessages: (state, action: PayloadAction<IMessage[]>) => {
      state.messages = action.payload;
    },

    updateMessage: (state, action: PayloadAction<IMessage>) => {
      const newMessage = state.messages.map((i: any) => i.messageId === action.payload.messageId ? action.payload : i);
      state.messages = newMessage;
    },

    deleteMessages: (state, action: PayloadAction<IMessage[]>) => {
      const messageIdsToDelete = action.payload.map((message) => message.messageId);
      state.messages = state.messages.filter((message) => !messageIdsToDelete.includes(message.messageId));
    }

  }
});

export const { addMessage, setMessages, updateMessage, deleteMessages } = userSlice.actions;

export default userSlice.reducer;
